import { z } from 'zod/v4';

// Please keep this in sync with https://gitlab.com/luminovo/product/epibator/-/blob/master/rust-workspace/domain-core/src/sources_api.rs#L22

export const sourcesApiValues = [
    'APCT',
    'Alba',
    'Alfatec',
    'Arrow',
    'AvnetAbacus',
    'AvnetAbacusV3',
    'AvnetApac',
    'AvnetEbv',
    'AvnetEbvV3',
    'AvnetSilica',
    'AvnetSilicaV3',
    'AvnetUsa',
    'AvnetUsaV3',
    'AlElektronik',
    'BetaLayout',
    'Blume',
    'Bossard',
    'Buerklin',
    'Digikey',
    'DigiKeyV4',
    'Ecomal',
    'Element14',
    'Eve',
    'Farnell',
    'Future',
    'Gatema',
    'Greenchips',
    'Gudeco',
    'Heilind',
    'Hexachip',
    'IBRRingler',
    'IcHub',
    'Kruse',
    'Ineltro',
    'AtlantikNetworxx',
    'Mev',
    'Lcsc',
    'LcscV3',
    'Master',
    'Mouser',
    'MultiCB',
    'MyArrow',
    'Newark',
    'Nexar',
    'Octopart',
    'Onlinecomponents',
    'Corestaff',
    'WinSource',
    'Orbweaver',
    'RapidElectronics',
    'RsComponents',
    'RmComponents',
    'Rochester',
    'ChipCart',
    'Rutronik',
    'SafePcb',
    'Samtec',
    'Schukat',
    'SiliconExpert',
    'Sos',
    'Sourcengine',
    'Stackrate',
    'Sluicebox',
    'Telcona',
    'Ti',
    'Tme',
    'TrustedParts',
    'Tti',
    'Unikey',
    'Venkel',
    'QuestComponents',
    'Weltron',
    'Wuerth',
    'WuerthEisos',
    'Wittig',
] as const;

export const SourcesApiRuntype = z.enum(sourcesApiValues);

export const ApiRelevanceRuntype = z.object({
    api: SourcesApiRuntype,
    relevant: z.boolean(),
});

export type ApiRelevanceDTO = z.infer<typeof ApiRelevanceRuntype>;
export type SourcesApiDTO = z.infer<typeof SourcesApiRuntype>;
